import { useState } from 'react'
import { API_BASE_URL } from '../config/api'

const Newsletter = () => {
  const [email, setEmail] = useState('')
  const [isSubscribed, setIsSubscribed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      const formData = new URLSearchParams()
      formData.append('email', email)

      const response = await fetch(`${API_BASE_URL}newsletter_subscribe.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      })

      const result = await response.json()

      if (result.status) {
        setIsSubscribed(true)
        setEmail('')
        setTimeout(() => setIsSubscribed(false), 5000)
      } else {
        setError(result.message || 'Failed to subscribe. Please try again.')
      }
    } catch (err) {
      setError('Failed to subscribe. Please try again.')
      console.error('Error subscribing to newsletter:', err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <section className="bg-gradient-to-br from-primary-dark via-primary-light to-primary-dark py-16 md:py-24 relative overflow-hidden animated-bg">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      <div className="floating-shapes"></div>
      <div className="particle-bg"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 border border-white/20 shadow-2xl">
            <div className="text-center mb-8">
              <div className="inline-block bg-white/20 rounded-full p-3 mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
                Stay Updated
              </h2>
              <p className="text-lg md:text-xl text-gray-100">
                Subscribe to our newsletter and never miss an event or update.
              </p>
            </div>
            
            <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                  className="flex-1 px-6 py-4 rounded-xl text-gray-900 focus:outline-none focus:ring-2 focus:ring-white shadow-lg text-base"
                />
                <button
                  type="submit"
                  disabled={isLoading || isSubscribed}
                  className={`bg-white text-primary-light hover:bg-gray-100 px-8 py-4 rounded-xl font-semibold transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl min-h-[56px] ${
                    isLoading || isSubscribed ? 'opacity-75 cursor-not-allowed' : ''
                  }`}
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center">
                      <svg className="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Subscribing...
                    </span>
                  ) : isSubscribed ? (
                    <span className="flex items-center justify-center">
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      Subscribed!
                    </span>
                  ) : (
                    'Subscribe'
                  )}
                </button>
              </div>
              {error && (
                <p className="mt-4 text-center text-red-200 text-sm font-medium">{error}</p>
              )}
              {isSubscribed && !error && (
                <p className="mt-4 text-center text-white text-sm font-medium">Thank you for subscribing! Check your email for confirmation.</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Newsletter

